export class DocumentApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async createDocumentV2({
    loanIdOrLegacyLoanNumber,
    subCompanyId,
    documentTypeId,
    formData,
    signal,
  }) {
    if (subCompanyId) {
      return this.#http.post(`/Document/sub-company/${subCompanyId}/v2`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        params: { documentTypeId },
        signal,
      });
    }

    return this.#http.post('/Document/v2', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: { loanIdOrLegacyLoanNumber, documentTypeId },
      signal,
    });
  }

  async editDocument({ documentId, ...params }) {
    return this.#http.put(`/Document/${documentId}`, params);
  }

  async getDocumentById({ documentId }) {
    return this.#http.get(`/Document/${documentId}`);
  }

  /**
   * POST /Document/{documentId}/calculation-fields — re-evaluates the saved document's calculation
   * fields and stores them where loan expressions (checklists, loan actions) read them.
   */
  async recalculateDocumentCalculationFields({ documentId }) {
    return this.#http.post(`/Document/${documentId}/calculation-fields`);
  }

  async deleteDocument({ documentId }) {
    return this.#http.delete(`/Document/${documentId}`);
  }

  async getDocumentsV2({
    loanIdOrLegacyLoanNumber,
    subCompanyId,
    includeDeleted,
    includeFieldsAndResults,
  }) {
    if (subCompanyId) {
      return this.#http.get(`/Document/sub-company/${subCompanyId}/v2`, {
        params: { includeDeleted },
      });
    }

    return this.#http.get(`/Document/filtered-initial-disclosures/${loanIdOrLegacyLoanNumber}/v2`, {
      params: { includeDeleted, includeFieldsAndResults },
    });
  }

  async copyDocumentToTargetLoan({ sourceLoanId, targetLoanId, documentIds }) {
    return this.#http.post('/Document/copy-to-target-loan', {
      sourceLoanId,
      targetLoanId,
      documentIds,
    });
  }
}
